import { render } from "./ApartmentFavButton.vue?vue&type=template&id=4fe0e851&scoped=true"
import script from "./ApartmentFavButton.vue?vue&type=script&lang=js"
export * from "./ApartmentFavButton.vue?vue&type=script&lang=js"

import "./ApartmentFavButton.vue?vue&type=style&index=0&id=4fe0e851&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe0e851"]])

export default __exports__